"use client";
/* 🔑 공용 원자 — 두 스킨(`_skins/*`)이 같이 씁니다. 스킨 고유의 모양은 여기 두지 않습니다 (`docs/base/11` §5-2). */

import { mediaSrc } from "../_lib/api";
import { useSite } from "../_lib/useSite";
import { BrandMark } from "./BrandMark";

/*
 * 브랜드 로고 자리 — 관리자가 올린 로고가 있으면 그 이미지, 없으면 `BrandMark` 칩.
 *
 * 🔑 **두 스킨이 같이 씁니다.** 칩의 크기·색·모서리는 부르는 쪽(헤더·푸터·로그인)이
 *    정하고(`className`), 로고 이미지는 **같은 크기의 상자**에 `object-contain` 으로 들어갑니다 —
 *    로고를 올려도 헤더 높이·정렬이 흔들리지 않습니다.
 *
 * 🔴 로고는 `api.` 의 상대 경로(`/site/images/logo?v=…`)라 `mediaSrc()` 로 BFF 를 거칩니다.
 *    `v=` 가 내용 해시라 관리자가 새로 올리면 주소가 바뀌어 캐시가 알아서 갈립니다.
 *
 * 🔑 장식입니다(`alt=""`) — 바로 옆에 서비스명 글자가 늘 함께 있습니다.
 *
 * 사용: `<BrandLogo className="grid size-6 place-items-center rounded-[…] bg-ink text-white" markClassName="size-3.5" />`
 */
export function BrandLogo({
  className,
  markClassName,
  imageClassName,
}: {
  /** 칩 상자 — 크기·배경·글자색·모서리 */
  className: string;
  /** 칩 안 `BrandMark` 의 크기 */
  markClassName: string;
  /** 로고 이미지 상자. 없으면 칩 상자에서 크기만 쓰지 말고 이 값으로 정하세요 */
  imageClassName: string;
}) {
  const { brand } = useSite();
  const src = mediaSrc(brand.logoUrl);

  if (src) {
    // eslint-disable-next-line @next/next/no-img-element -- 관리자 업로드 이미지, BFF 경유(최적화 대상 아님)
    return <img src={src} alt="" aria-hidden="true" className={`flex-none object-contain ${imageClassName}`} />;
  }

  return (
    <span className={className}>
      <BrandMark className={markClassName} />
    </span>
  );
}
